export function canShareWithTeam(team) {
  return team?.is_owner || team?.role === 'owner' || team?.role === 'admin' || team?.role === 'editor';
}

export function isOwnedPersonalCloudWorkspace(ws, currentUserId) {
  if (!ws?.id || ws.storage === 'local' || ws.storage === 'git') return false;
  if (ws.type === 'team' || ws.source === 'team') return false;
  const ownerId = ws.owner_id || ws.user_id || ws.owner?.id;
  return ws.role === 'owner' || ownerId === currentUserId;
}

export function canShareWorkspaceWithTeam(workspace, currentUserId) {
  return isOwnedPersonalCloudWorkspace(workspace, currentUserId);
}

export function isTeamWorkspace(workspace) {
  return workspace?.type === 'team' || workspace?.source === 'team';
}

export function canPublishTeamWorkspace(workspace, canPublishPlan) {
  if (!workspace?.id || workspace.storage === 'local') return false;
  if (!isTeamWorkspace(workspace)) return false;
  if (workspace.can_edit === false) return false;
  const role = workspace.role || workspace.user_role;
  if (role === 'viewer') return false;
  return Boolean(canPublishPlan);
}
